import React from 'react';

import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';

import { platformMessages } from 'ml-components-platform-react';
import metadata from './MLWizardPageActions.metadata.json5';
import styles from './MLWizardPageActions.module.scss';

function MLWizardPageActions(props) {
    const translator = useTranslator();

    const {
        onNext,
        buttonText,
        message,
        disabled,
        navButtonsContent_Ext
    } = props;

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onNext: onNext
        }
    };

    const generateContinueSectionOverrides_Ext = () => {
        if (navButtonsContent_Ext) {
            const overrides = [{
                'MLWizardPageActioinsContainer': {
                    content: navButtonsContent_Ext
                }
            }];
            return Object.assign({}, ...overrides);
        }
    };

    const overrides = {
        ...generateContinueSectionOverrides_Ext(),
        nextButton: {
            content: buttonText,
            disabled: disabled
        },
        message: {
            content: translator(message)
        }
    };

    return <>
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    </>;
}

MLWizardPageActions.propTypes = {
    onNext: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    disabled: PropTypes.bool,
    message: PropTypes.shape({})
};

MLWizardPageActions.defaultProps = {
    buttonText: platformMessages.mlNext,
    disabled: false,
    message: undefined
};

export default MLWizardPageActions;
